import { Box, styled } from '@mui/material';

export const CenteredColumnContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  alignItems: 'center',
  gap: '1em',
});
